@for (toast of toasts(); track toast.id) {
<div
  class="border-border shadow-elevated pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-2xl border-l-4 bg-white p-4"
  [class]="
      toast.type === 'error' ? 'border-l-coral' : toast.type === 'success' ? 'border-l-turquoise' : 'border-l-accent'
    "
  role="alert"
  aria-live="polite">
  <p class="text-ink flex-1 text-sm">{{ toast.message }}</p>
  <button
    type="button"
    class="text-muted hover:text-ink -m-1 p-1 transition-colors"
    (click)="dismiss(toast.id)">
    <app-icon
      name="close"
      [size]="16" />
    <span class="sr-only">Cerrar</span>
  </button>
</div>
}
